import { inject, observer, Provider } from "mobx-react";
import * as React from "react";
import { Route, RouteComponentProps } from "react-router-dom";
import { AddButton } from "../Buttons/AddButton";
import { Area } from "../General/Area";
import { AreaAside } from "../General/AreaAside";
import { Link } from "../General/Link";
import { Toolbar } from "../General/Toolbar";
import { ActivePortalIcon } from "../Icons/ActivePortalIcon";
import * as PortalManagement from "../PortalManagement";
import { IAreaUiInfo } from "../States/AreaUiInfo";
import { AppStore } from "../Stores/AppStore";
import { PortalStore } from "../Stores/PortalStore";
import { Strings } from "../Stores/StringsStore";
import { Urls } from "../Urls";
import { newGuid } from "../Utilities";
import { PortalEdit } from "./PortalEdit";


interface IPortalManagementRouteProps extends RouteComponentProps<{}> { }

@observer
export class Portals extends React.Component<IPortalManagementRouteProps, {}> {

	store: PortalStore = new PortalStore();
	searchTimeoutHandle: number;
	wasCollapsed: boolean;

	componentDidMount() {
		this.store.search();
		this.store.loadUiSettings();
		window.addEventListener('orientationchange', this.handleOrientation);
	}

	componentWillUnmount() {
		window.removeEventListener("orientationchange", this.handleOrientation);
	}

	add = () => {
		this.store.isEditMode = false;
		AppStore.keepOnPage(Urls.portals + "/" + newGuid(), true);
		this.store.areaUiInfo.selectCollapse();
	}

	handleOrientation = () => {
		if (screen.width > screen.height) {
			if (screen.width >= 880 && this.store.areaUiInfo.isCollapsed) {
				this.store.areaUiInfo.isCollapsed = false;
				this.wasCollapsed = true;
			}
		}
		else if (!this.store.areaUiInfo.isCollapsed && this.wasCollapsed) {
			this.store.areaUiInfo.isCollapsed = true;
			this.wasCollapsed = false;
		}
	}

	render() {
		let noCollapse = this.props.children === null || !this.store.currentFocusedItem;
		let aside = <AreaAside noCollapse={noCollapse}>
			<Toolbar>
				<AddButton title={Strings.settings.portalsAddButtonTooltip} onClick={this.add} />
			</Toolbar>
			<div className="area-grid__aside-content">
				<h1>{this.store.isEditMode ? Strings.settings.portalsEditLabel : Strings.settings.portalsAddLabel}</h1>
				<div className="list-simple">
					<ul>
						{this.store.model.map(item => {
							return <PortalItem key={item.id} item={item} />
						})}
					</ul>
				</div>
			</div>
		</AreaAside>

		return <Provider store={this.store} areaUiInfo={this.store.areaUiInfo}>
			<Area asideComponent={aside}>
				<Route path={`${this.props.match.url}/:id`} component={PortalEdit} />
			</Area>
		</Provider>;
	}
}

interface IPortaItemProps extends IAreaUiInfo {
	item: PortalManagement.PortalInfo;
	store?: PortalStore;
}

@inject("store")
@inject("areaUiInfo")
@observer
class PortalItem extends React.Component<IPortaItemProps, {}>{

	render() {
		return <li key={this.props.item.id} className={this.props.store.currentFocusedItem === this.props.item.id ? "is--item-open" : ""}><Link to={Urls.portals + "/" + this.props.item.id} action={this.props.areaUiInfo.selectCollapse}>
			{this.props.item.name}
			<span className="list-simple__additional">
				{this.props.item.isCurrent ? <ActivePortalIcon /> : null}
			</span>
		</Link></li>
	}
}
